"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SEND_POST_BACK = void 0;
exports["default"] = sendPostback;
var SEND_POST_BACK = 'WEB_CHAT/SEND_POST_BACK';
exports.SEND_POST_BACK = SEND_POST_BACK;
function sendPostback(value) {
  return {
    type: SEND_POST_BACK,
    payload: {
      value: value
    }
  };
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJTRU5EX1BPU1RfQkFDSyIsImV4cG9ydHMiLCJzZW5kUG9zdGJhY2siLCJ2YWx1ZSIsInR5cGUiLCJwYXlsb2FkIl0sInNvdXJjZVJvb3QiOiJjb3JlOi8vLyIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2FjdGlvbnMvc2VuZFBvc3RCYWNrLmpzIl0sInNvdXJjZXNDb250ZW50IjpbImNvbnN0IFNFTkRfUE9TVF9CQUNLID0gJ1dFQl9DSEFUL1NFTkRfUE9TVF9CQUNLJztcblxuZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24gc2VuZFBvc3RiYWNrKHZhbHVlKSB7XG4gIHJldHVybiB7XG4gICAgdHlwZTogU0VORF9QT1NUX0JBQ0ssXG4gICAgcGF5bG9hZDogeyB2YWx1ZSB9XG4gIH07XG59XG5cbmV4cG9ydCB7IFNFTkRfUE9TVF9CQUNLIH07XG4iXSwibWFwcGluZ3MiOiI7Ozs7Ozs7QUFBQSxJQUFNQSxjQUFjLEdBQUcseUJBQXlCO0FBQUNDLE9BQUEsQ0FBQUQsY0FBQSxHQUFBQSxjQUFBO0FBRWxDLFNBQVNFLFlBQVlBLENBQUNDLEtBQUssRUFBRTtFQUMxQyxPQUFPO0lBQ0xDLElBQUksRUFBRUosY0FBYztJQUNwQkssT0FBTyxFQUFFO01BQUVGLEtBQUssRUFBTEE7SUFBTTtFQUNuQixDQUFDO0FBQ0gifQ==